import type { LevelConfig } from '../types'
import { padRow } from '../utils'

export const levelSelection: LevelConfig = {
  grid: [
    padRow(
      padRow(
        [
          null,
          'SE',
          'WE',
          'WE',
          'WE',
          {
            track: 'WE',
            exit: 'E',
            vehicle: { type: 'npc', wagons: 16 },
          },
        ],
        'prepend',
        false,
      ),
      'append',
    ),
    padRow([null, 'NE', 'WE', 'WE', 'WE', 'SW'], 'prepend', false),
    padRow([{ track: 'WE' }, 'WE', 'WE', 'WE', 'WE', 'NW'], 'prepend'),
  ],
  goal: { sequence: ['PLACEHOLDER'] },
}
